<template>
  <svg
    class="svg-icon"
    :style="customStyle"
  >
    <use :xlink:href="`#icon-${props.name}`" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  // 自定义宽度，支持数字（默认单位 px）和字符串（如 '24px', '2em'）
  width: {
    type: [Number, String],
    default: '1em'
  },
  // 自定义高度，支持数字（默认单位 px）和字符串
  height: {
    type: [Number, String],
    default: '1em'
  },
  // 自定义填充颜色
  fill: {
    type: String,
    default: undefined
  },
  // 自定义类名
  className: {
    type: String,
    default: ''
  }
});

// 计算自定义样式
const customStyle = computed(() => {
  const style: any = {};

  if (props.width) {
    style.width = typeof props.width === 'number' ? `${props.width}px` : props.width;
  }

  if (props.height) {
    style.height = typeof props.height === 'number' ? `${props.height}px` : props.height;
  }

  if (props.fill) {
    style.fill = props.fill;
  }

  return style;
});
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: -0.15em;
  overflow: hidden;
  fill: currentColor; /* 继承父元素的文字颜色 */
}
</style>
